import { FunctionComponent } from 'react'
import PlaylistTeaserComponents from '@components/Teaser/Playlist'
import { getVideoData } from '../utils'
import { TeaserVideo } from '../types'

const { VideoInfo } = PlaylistTeaserComponents

interface ExtraDataProps {
  video: TeaserVideo
}

const ExtraData: FunctionComponent<ExtraDataProps> = ({ video }) => {
  const videoData = getVideoData(video)

  if (!videoData) {
    return null
  }

  return videoData ? <VideoInfo>{videoData.formattedDuration}</VideoInfo> : null
}

export default ExtraData
